// Utilidades centralizadas para impresion de etiquetas via QZ Tray
// Permite definir una impresora por defecto en localStorage para evitar
// que el usuario tenga que seleccionar la impresora en cada impresion.
import { toast } from 'sonner';

export const DEFAULT_PRINTER_KEY = 'label_default_printer';

export const getDefaultPrinter = () => {
  try {
    return localStorage.getItem(DEFAULT_PRINTER_KEY) || '';
  } catch {
    return '';
  }
};

export const setDefaultPrinter = (name) => {
  try {
    if (name) {
      localStorage.setItem(DEFAULT_PRINTER_KEY, name);
    } else {
      localStorage.removeItem(DEFAULT_PRINTER_KEY);
    }
  } catch {
    /* noop */
  }
};

export const ensureQZReady = async () => {
  if (!window.qz) {
    throw new Error('QZ Tray no esta disponible. Instalalo y ejecutalo antes de imprimir.');
  }
  if (!qz.websocket.isActive()) {
    await qz.websocket.connect();
  }
  return true;
};

export const listPrinters = async () => {
  await ensureQZReady();
  const printers = await qz.printers.find();
  return printers || [];
};

const sendRawEPL = async (printerName, eplCommands) => {
  const config = qz.configs.create(printerName);
  await qz.print(config, [{ type: 'raw', format: 'plain', data: eplCommands }]);
};

// Envia EPL a la impresora por defecto si esta configurada y disponible.
// Si solo hay 1 impresora, la usa. En caso contrario devuelve la lista para
// que el caller muestre un selector.
// Retorna { sent, usedPrinter, printers, needsSelection }
export const printEPL = async (eplCommands) => {
  await ensureQZReady();
  const printers = await qz.printers.find();
  if (!printers || printers.length === 0) {
    throw new Error('No se encontraron impresoras');
  }
  const def = getDefaultPrinter();
  if (def && printers.includes(def)) {
    await sendRawEPL(def, eplCommands);
    return { sent: true, usedPrinter: def, printers, needsSelection: false };
  }
  if (printers.length === 1) {
    await sendRawEPL(printers[0], eplCommands);
    return { sent: true, usedPrinter: printers[0], printers, needsSelection: false };
  }
  return { sent: false, printers, needsSelection: true };
};

export const printToSpecific = async (printerName, eplCommands) => {
  await ensureQZReady();
  await sendRawEPL(printerName, eplCommands);
  return { sent: true, usedPrinter: printerName };
};
